import React from 'react';

export default function MultiLineText({ details }) {
  return (
    <div
      css={`
        font-size: ${details?.font_size || '1.2rem'};
        font-weight: ${details?.font_size || '400'};
        color: ${details?.color || '#4F4F4F'};
        display: flex;
        flex-direction: ${details?.orientation
          ? details?.orientation === 'row'
            ? 'row'
            : 'column'
          : 'column'};
      `}
    >
      {details?.lines.map((line) => {
        return (
          <span
            css={`
              font-size: ${line?.font_size || '1.2rem'};
              font-weight: ${line?.font_size || '400'};
              color: ${line?.color || '#4F4F4F'};
            `}
          >
            {line}
          </span>
        );
      })}
    </div>
  );
}
